// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__UpxMy","spinnerCenter":"Loader_spinnerCenter__ULQfM","spinnerBlade":"Loader_spinnerBlade__Yhh+9","spinner-fade9234":"Loader_spinner-fade9234__954jk"};